module.exports = __webpack_public_path__ + "img/inn2.476ab59f.jpg";